import company from "../data/company.json";
import { PREORDER_DAYS_RANGE } from "../lib/preorderLeadTime";

export const BUSINESS = {
  entity: company.legal_name,
  address: `${company.address_line_1}, ${company.address_city}`,
  whatsapp: company.business_phone.replace(/\s/g, ""),
  whatsappUrl: `https://wa.me/${company.whatsapp_phone_e164}`,
  // Warranty-extension opt-in channel. Single source of truth; override via
  // REACT_APP_SUPPORT_WHATSAPP_NUMBER. wa.me needs digits only.
  supportWhatsappNumber: process.env.REACT_APP_SUPPORT_WHATSAPP_NUMBER || "+91-9650-38134",
  supportWhatsappUrl: `https://wa.me/${(process.env.REACT_APP_SUPPORT_WHATSAPP_NUMBER || "+91-9650-38134").replace(/\D/g, "")}`,
  discord: "https://discord.gg/ksmtpU6V7C",
  instagram: "https://www.instagram.com/loadout.co.in/",
  email: company.support_email,
  calendly: company.calendly_consult_url,
  gst: company.gstin,
  cin: null,
};

// Nav — full spec-current list (KEYBOARDS · … · DROPS · THE LAB).
export const NAV_ITEMS = [
  { label: "KEYBOARDS", href: "/collections/keyboards" },
  { label: "MICE", href: "/collections/mice" },
  { label: "MOUSEPADS", href: "/collections/mousepads" },
  { label: "KEYCAPS", href: "/collections/keycaps" },
  { label: "AUDIO", href: "/collections/audio" },
  { label: "SWITCHES", href: "/collections/switches" },
  { label: "ACCESSORIES", href: "/collections/accessories" },
  { label: "PCB MODULES", href: "/collections/pcb-modules" },
  { label: "DROPS", href: "/drops" },
  { label: "THE LAB", href: "/operator-lab" },
];

// Four flagship category tiles for [5] The Armory.
export const CATEGORY_TILES = [
  {
    key: "keyboards",
    productType: "Keyboard",
    title: "KEYBOARDS",
    href: "/collections/keyboards",
    subhead: "Mechanical · Hall Effect · Optical",
  },
  {
    key: "mice",
    productType: "Mouse",
    title: "MICE",
    href: "/collections/mice",
    subhead: "Pixart 3395 · 3950 · 3955 · 36g to 65g",
  },
  {
    key: "mousepads",
    productType: "Mousepad",
    title: "MOUSEPADS",
    href: "/collections/mousepads",
    subhead: "Speed · Control · Balanced",
  },
  {
    key: "keycaps",
    productType: "Keycap",
    title: "KEYCAPS",
    href: "/collections/keycaps",
    subhead: "PBT · ABS · Sculpted · Flat",
  },
];

export const FEATURED_DROP = {
  handle: "hm-lab-z-neo-8k-usb-gaming-hub",
  eyebrow: "FEATURED DROP",
  eyebrowMicrocopy: "USB HUB · 8K POLLING · DISPLAY",
  headline1: "HM LAB Z-NEO 8K.",
  headline2: "ONE HUB. EVERY PERIPHERAL.",
  productName: "HM Lab Z-NEO 8K USB Gaming Hub",
  fallbackPrice: "₹4,299",
  body:
    "Connect all your peripherals through a single powered hub. Monitor telemetry on the built-in display. 8K polling for every device on the rig.",
  href: "/p/hm-lab-z-neo-8k-usb-gaming-hub",
};

export const LAB_ARTICLES = [
  {
    category: "GUIDE",
    title: "The Grip Index — How Surface Choice Affects Your Aiming",
    excerpt:
      "Speed pads bias flick recovery, control pads bias microcorrection. A field guide to which surface fits your engagement style.",
    href: "/operator-lab/the-grip-index",
  },
  {
    category: "BUYER'S NOTES",
    title: "Building a ₹15,000 Loadout That Doesn't Feel Like ₹15,000",
    excerpt:
      "Three complete builds, each within budget, each competitively viable. Notes on where to cut and where to spend.",
    href: "/operator-lab/15000-loadout-build",
  },
  {
    category: "TECH DEEP-DIVE",
    title: "Hall Effect vs Mechanical — A Clinical Comparison",
    excerpt:
      "Latency figures, actuation curves, and durability data across five popular boards. Numbers, not opinions.",
    href: "/operator-lab/hall-effect-vs-mechanical",
  },
];

export const TRUST_ITEMS = [
  { label: "AUTHENTICITY GUARANTEED", icon: "shield" },
  { label: "UPI AVAILABLE", icon: "upi" },
  { label: "18-MO WARRANTY · EASY RMA", icon: "warranty" },
  { label: "IN-STOCK: 2–4 DAYS", icon: "truck" },
  { label: `PRE-ORDER: ${PREORDER_DAYS_RANGE} DAYS`, icon: "hourglass" },
  { label: "7-DAY RETURNS", icon: "return" },
  { label: "WHATSAPP SUPPORT", icon: "chat", href: BUSINESS.whatsappUrl },
];
